<script setup lang="ts">
import { computed } from "vue";
import { FormLabel, FormSelect } from "@/components/Base/Form";
import countries from "@/assets/json/countries.json";

// Import countries list. Since we don't have it yet, I will inline a basic list or load it.
// For now, let's use a computed property with a simplified list, but structured to support full list later.

interface Props {
  modelValue: string | null;
  label?: string;
  placeholder?: string;
  error?: string;
}

const props = defineProps<Props>();
const emit = defineEmits(["update:modelValue"]);

const countryList = [
  { code: "ES", name: "España" },
  { code: "PT", name: "Portugal" },
  { code: "FR", name: "Francia" },
  { code: "IT", name: "Italia" },
  { code: "DE", name: "Alemania" },
  { code: "GB", name: "Reino Unido" },
  { code: "US", name: "Estados Unidos" },
  { code: "AR", name: "Argentina" },
  { code: "BR", name: "Brasil" },
  { code: "MX", name: "México" },
  { code: "CL", name: "Chile" },
  { code: "CO", name: "Colombia" },
  { code: "PE", name: "Perú" },
  { code: "VE", name: "Venezuela" },
  { code: "UY", name: "Uruguay" },
  { code: "CU", name: "Cuba" },
  { code: "CN", name: "China" },
  { code: "JP", name: "Japón" },
  { code: "RU", name: "Rusia" },
  // Add more as needed
].sort((a, b) => a.name.localeCompare(b.name));

const value = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", val);
  },
});
</script>

<template>
  <div class="flex-col block">
    <FormLabel v-if="label" htmlFor="country-select">{{ label }}</FormLabel>
    <FormSelect
      id="country-select"
      v-model="value"
      :class="{ 'border-danger': error }"
    >
      <option value="" disabled>{{ placeholder || 'Selecciona un país' }}</option>
      <option v-for="c in countryList" :key="c.code" :value="c.code">
        {{ c.name }}
      </option>
    </FormSelect>
    <div v-if="error" class="text-danger text-xs mt-1">{{ error }}</div>
  </div>
</template>
